import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './PickupDateSelector.css';

// Sagawa pickup time slot codes
const TIME_SLOTS = [
  { code: '00', labelKey: 'timeSlot00' },
  { code: '09', labelKey: 'timeSlot09' },
  { code: '12', labelKey: 'timeSlot12' },
  { code: '15', labelKey: 'timeSlot15' },
  { code: '18', labelKey: 'timeSlot18' },
];

export default function PickupDateSelector({
  isOpen,
  onClose,
  onConfirm,
  loading,
  defaultTimeSlot = '09',
  isReschedule = false
}) {
  const { t } = useTranslation();

  // Default to tomorrow
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const defaultDate = tomorrow.toISOString().split('T')[0];

  const [selectedDate, setSelectedDate] = useState(defaultDate);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(defaultTimeSlot || '09');

  // Reset state when dialog opens
  useEffect(() => {
    if (isOpen) {
      setSelectedDate(defaultDate);
      setSelectedTimeSlot(defaultTimeSlot || '09');
    }
  }, [isOpen, defaultDate, defaultTimeSlot]);

  const handleConfirm = () => {
    if (selectedDate && selectedTimeSlot) {
      onConfirm(selectedDate, selectedTimeSlot);
    }
  };

  if (!isOpen) {
    return null;
  }

  // Minimum date is tomorrow
  const minDate = defaultDate;

  const title = isReschedule
    ? t('matchDetails.pickupDate.rescheduleTitle', 'Reschedule Pickup')
    : t('matchDetails.buttons.selectPickupDate');

  const confirmButtonText = loading
    ? t('matchDetails.buttons.schedulePickupLoading')
    : isReschedule
      ? t('matchDetails.pickupDate.confirmReschedule', 'Confirm Reschedule')
      : t('matchDetails.buttons.confirmPickup');

  return (
    <div className="pickup-date-overlay" onClick={onClose}>
      <div className="pickup-date-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>

        <div className="pickup-date-content">
          <div className="pickup-field">
            <label htmlFor="pickup-date">
              {t('matchDetails.pickupDate.dateLabel', 'Pickup Date')}:
            </label>
            <input
              id="pickup-date"
              type="date"
              value={selectedDate}
              min={minDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="pickup-field">
            <label htmlFor="pickup-time-slot">
              {t('matchDetails.pickupDate.timeSlotLabel', 'Pickup Time Slot')}:
            </label>
            <select
              id="pickup-time-slot"
              value={selectedTimeSlot}
              onChange={(e) => setSelectedTimeSlot(e.target.value)}
              disabled={loading}
              className="pickup-time-select"
            >
              {TIME_SLOTS.map((slot) => (
                <option key={slot.code} value={slot.code}>
                  {slot.code} - {t(`userSettings.shippingConfig.${slot.labelKey}`)}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="pickup-date-actions">
          <button
            className="cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            {t('common.cancel', 'Cancel')}
          </button>
          <button
            className="confirm-button"
            onClick={handleConfirm}
            disabled={loading || !selectedDate || !selectedTimeSlot}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}
